export default "__VITE_ASSET__9492ecc6__"